var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReplyCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_128_191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 9C2 4.58172 5.58172 1 10 1H42C46.4183 1 50 4.58172 50 9V41C50 45.4183 46.4183 49 42 49H10C5.58172 49 2 45.4183 2 41V9Z",
    fill: "#FFE3D4",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 1.5H42C46.1421 1.5 49.5 4.85786 49.5 9V41C49.5 45.1421 46.1421 48.5 42 48.5H10C5.85786 48.5 2.5 45.1421 2.5 41V9C2.5 4.85786 5.85787 1.5 10 1.5Z",
    stroke: "#FF7D37",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 40C32.0623 39.9277 29.1836 39.1601 26.6 37.76C23.7548 36.2809 21.157 34.368 18.9 32.09C16.6233 29.838 14.7135 27.2432 13.24 24.4C11.8389 21.8168 11.0711 18.9379 11 16C11 14.28 12.61 12.61 13.29 12C14.29 11.09 15.85 10 16.98 10C17.7893 10.1267 18.5269 10.538 19.06 11.16C19.8141 11.8737 20.5065 12.6498 21.13 13.48C21.57 14.03 23.73 16.88 23.73 18.25C23.73 19.37 22.46 20.15 21.12 20.97C20.6217 21.2761 20.1409 21.61 19.68 21.97C19.27 22.3 19.19 22.48 19.18 22.52C21.1405 26.5835 24.4281 29.857 28.5 31.8C28.5 31.8 28.71 31.72 29.05 31.3C29.3963 30.8402 29.7136 30.3593 30 29.86C30.83 28.52 31.61 27.25 32.73 27.25C34.1 27.25 36.94 29.41 37.5 29.85C38.3302 30.4735 39.1063 31.1659 39.82 31.92C40.4494 32.4499 40.8681 33.1879 41 34C41 35.14 39.93 36.7 39 37.7C38.37 38.39 36.7 40 35 40Z",
    fill: "#FF7D37"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_128_191",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_128_191"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_128_191",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplyCall);
export default __webpack_public_path__ + "static/media/reply-call.043e307e0856847d1e91f252fb8ce396.svg";
export { ForwardRef as ReactComponent };